import ManagerContact from 'app/components/Core/Rental/Form/ManagerContact'
import { RecordType } from 'app/constants/GlobalTypes'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import useTranslation from 'app/lib/hooks/useTranslation'

type ManagerContactProps = React.ComponentProps<typeof ManagerContact>

export default function useManagerContactForm() {
  const { tCore } = useTranslation({
    scope: 'drawer',
    recordType: RecordType.checkout
  })

  const { drawerfy } = useFeedbacker()

  const open = (managerContactProps: ManagerContactProps) => {
    const content = (
      <ManagerContact
        {...managerContactProps}
        props={{
          ...managerContactProps.props,
          onSuccess: () => {
            drawerfy.close()
            managerContactProps.props?.onSuccess?.()
          }
        }}
      />
    )

    drawerfy.open({
      content,
      title: tCore({
        id: 'manager_contact_title'
      }),
      width: 600,
      drawerType: 'page',
      push: false
    })
  }

  return { open, close: drawerfy.close }
}
